import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';
import * as PATHS from 'constants/paths';

import { SideMenu } from 'components/_basic/SideMenu/SideMenu';

import styles from './UserAccountLayout.styles';

export const UserAccountLayout: FC = () => {
  const { t } = useTranslation();

  const menuItems = useMemo(
    () => [
      { title: t('accountSettings'), path: PATHS.ACCOUNT_SETTINGS },
      { title: t('subscriptions'), path: PATHS.ACCOUNT_SUBSCRIPTIONS },
      { title: t('paymentInfo'), path: PATHS.ACCOUNT_PAYMENT_INFO },
    ],
    [t],
  );

  return (
    <Box sx={styles.page}>
      <Box sx={styles.contentWrapper}>
        <SideMenu menuItems={menuItems} />
        <Box sx={styles.wrapper}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
